import jobPostRoutes from './jobPostRoutes';

const seekerRoutes = [...jobPostRoutes];

export default seekerRoutes;
